import styled, { css } from 'styled-components';
import { Swiper } from 'swiper/react';

import LinkWithLocale from '@/components/LinkWithLocale/LinkWithLocale';

export const ScrollerSection = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  margin-left: 40px;
`;

export const ScrollerLabel = styled.p`
  font-size: 15px;
  text-decoration: none;
  text-transform: uppercase;
  white-space: nowrap;
  margin-bottom: 18px;
  ${({ theme }) => css`
    color: ${theme.colors.almostBlack};
    font-family: ${theme.fonts.subtitleFont};
  `}
`;

export const StyledSwiper = styled(Swiper)`
  width: 100%;
  overflow: hidden;

  .swiper-slide {
    width: calc((100% - 32px) / 3);
  }
`;

export const SwiperWrapper = styled.div`
  position: relative;
`;

export const NavigationButton = styled.button<{ $type: 'next' | 'prev' }>`
  position: absolute;
  z-index: 2;
  top: calc(50% - 16px);
  transform: translateY(-50%);
  pointer-events: all;
  appearance: none;
  border: none;
  padding: 0;
  background: ${({ theme }) => theme.colors.white};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  cursor: pointer;
  transition: background-color 200ms ease-in-out;
  ${({ $type }) => ($type === 'next' ? 'right: 8px;' : 'left: 8px;')};

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }

  &:hover {
    background: ${({ theme }) => theme.colors.primaryBlue};

    svg path {
      fill: ${({ theme }) => theme.colors.white};
    }
  }

  svg {
    height: 18px;
    width: 18px;

    path {
      fill: ${({ theme }) => theme.colors.almostBlack};
      transition: fill 200ms ease-in-out;

      @media (prefers-reduced-motion: reduce) {
        transition: none;
      }
    }
  }

  &.swiper-button-disabled {
    display: none;
  }
`;

export const ScrollerItemLabel = styled.span`
  align-self: flex-start;
  font-size: 14px;
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  padding-bottom: 3px;
  border-bottom: 2px solid ${({ theme }) => theme.colors.primaryBlue};
  -webkit-mask:
    conic-gradient(at bottom 0px left 0px, #0000 -180deg, #000 0) 0
      var(--_i, 200%) / var(--_i, 0px) 200% border-box no-repeat,
    linear-gradient(#000 0 0) padding-box no-repeat;
  mask:
    conic-gradient(at bottom 0px left 0px, #0000 -180deg, #000 0) 0
      var(--_i, 200%) / var(--_i, 0px) 200% border-box no-repeat,
    linear-gradient(#000 0 0) padding-box no-repeat;
  transition:
    color 0.3s,
    -webkit-mask-position 0.3s 0.3s,
    mask-position 0.3s 0.3s;
  ${({ theme }) => css`
    color: ${theme.colors.almostBlack};
    font-family: ${theme.fontFamilies.openSans};
  `}

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

export const ScrollerItemLink = styled(LinkWithLocale)`
  display: flex;
  flex-direction: column;
  text-decoration: none;
  cursor: pointer;

  &:hover img {
    transform: scale(1.05);
  }

  &:hover ${ScrollerItemLabel} {
    --_i: 100%;
    transition:
      color 0s,
      -webkit-mask-size 0.3s 0.3s,
      mask-size 0.3s 0.3s;
    color: ${({ theme }) => theme.colors.primaryBlue};

    @media (prefers-reduced-motion: reduce) {
      transition: none;
    }
  }
`;

export const ScrollerItemImageWrapper = styled.div`
  width: 100%;
  aspect-ratio: 4 / 5;
  position: relative;
  overflow: hidden;
  margin-bottom: 12px;

  img {
    transition: transform 500ms ease-in-out;

    @media (prefers-reduced-motion: reduce) {
      transition: none;
    }
  }
`;

export const MobileScrollerWrapper = styled.div`
  padding: 16px 20px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.mediumGrey};
  position: relative;
`;

export const MobileScrollerLabel = styled.p`
  font-weight: 600;
  margin-bottom: 12px;
  ${({ theme }) => css`
    font-size: ${theme.fontSizes.p2};
    line-height: ${theme.lineHeights.p2};
    color: ${theme.colors.almostBlack};
    font-family: ${theme.fontFamilies.openSans};
  `}
`;

export const MobileScrollerList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: 16px 12px;
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const MobileScrollerListItem = styled.li`
  width: calc((100% - 24px) / 3);

  a {
    text-transform: none;
  }
`;

export const MobileScrollerItemLabel = styled.span`
  font-size: 13px;
  font-weight: 400;
  ${({ theme }) => css`
    color: ${theme.colors.almostBlack};
    font-family: ${theme.fontFamilies.openSans};
  `}
`;

export const MobileScrollerItemLink = styled(LinkWithLocale)`
  display: flex;
  flex-direction: column;
  text-decoration: none;
  width: 100%;
  cursor: pointer;

  &:hover img {
    transform: scale(1.05);
  }

  &:hover ${MobileScrollerItemLabel} {
    color: ${({ theme }) => theme.colors.primaryBlue};
  }
`;

export const MobileScrollerItemImageWrapper = styled.div`
  width: 100%;
  aspect-ratio: 4 / 5;
  overflow: hidden;
  margin-bottom: 8px;

  img {
    transition: transform 500ms ease-in-out;

    @media (prefers-reduced-motion: reduce) {
      transition: none;
    }
  }
`;
